export default __webpack_public_path__ + "static/media/257.60d28752.png";